import { useEffect, useState } from "react"

import classes from './DaysDifference.module.css'
import { getDaysDifference } from "../../../../lib/dateScripts"

export default function DaysDifference({date, plus, showZero = false}) {
    let warningClass = "";
    const days = getDaysDifference(date);

    if (days <= 0) {
        warningClass = 'red';
    } else if (days <= 1) {
        warningClass = 'orange';
    } else if (days <= 2) {
        warningClass = 'yellow';
    }

    // old code
    // const [warningClass, setWarningClass] = useState(null)
 
    // useEffect(() => {
    //     let days = getDaysDifference(date)

    //     if (days <= 0) {
    //         setWarningClass('red')
    //     } else if (days <=1) {
    //         setWarningClass('orange')
    //     } else if (days <=2) {
    //         setWarningClass('yellow')
    //     } else {
    //         setWarningClass('')
    //     }
    // }, [date])

    const dayCount = Math.abs(getDaysDifference(date) || 0) + (plus ? plus : 0)
    if (!date || (dayCount === 0 && !showZero)) {
        return null
    }

    return <>
        <div className={`${classes.container} ${warningClass ? classes[warningClass] : ''}`} >
            {dayCount}
        </div>
    </>
}